// =====================================================================
// IMAGE REGISTRY — Light-Hearted Healing Centre & Expansion School
// =====================================================================
// Each entry below is mapped to one of the 28 photos you'll upload.
// The URL is currently a curated placeholder so the site looks polished
// in the meantime. When you upload your real photo, I'll just swap the
// URL string below. The `filename` comment shows which photo goes where.
// =====================================================================

export const IMAGES = {
  // Page 1 Hero — REPLACE WITH: 3.IMGP1868
  hero: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=2000&q=80",

  // Page 2 About heart — Coromandel Aroha-Nui logo (transparent background)
  heartLogo: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/asmv0j1d_Coromandel%20Aroha-%20Nui%20Logo.png",

  // Page 3 Welcome stretch — REAL PHOTO: 3.IMGP1868 (Coromandel beach)
  welcomeStretch: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/0892jdlv_3.IMGP1868.jpeg",

  // ---------- NEW EXPERIENCE SECTION (6 gold-framed hearts) ----------
  // Spiritual Awakening — Healing Heart
  exp1: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/uugjmxcs_Healing%20Heart.jpg",
  // Nature & Adventure — 21.MGP1653
  exp2: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/xlmczris_21.%20MGP1653.JPG",
  // Connection — 23.IGP0539
  exp3: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/an5rtb00_23.%20_IGP0539.jpg",
  // Relaxing Day — Chang Keaw Thai Massage logo
  exp4: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/ic9c19sy_logoo-big.jpg.webp",
  // Freedom to Be You — IMGP 9676
  exp5: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/r72uc4ha_IMGP%209676%20.jpg",
  // Delicious Food — pic.jpg
  exp6: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/4uatf5px_pic.jpg",

  // ---------- RETREAT OPTIONS (Choose Your Journey) ----------
  miniRetreat: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/1bxhvg2u_8.IMGP3832.jpg",     // 8.IMGP3832
  weekImmersion: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/ntb9gq4g_14.IMGP1683.JPG", // 14.IMGP1683

  // ---------- ITINERARY (7 day photos) ----------
  day1: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/cypm817p_%20Healing%20hands%20holding%20a%20gold%20%20green%20%20toroidal%20energy%20heart%20copy.png", // Healing hands holding gold-green toroidal heart
  day2: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/prjjmw07_IMGP9763.jpeg",   // IMGP9763
  day3: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/ntb0dtq8_IMGP1665.JPG", // 10.IMGP1665 (revised kauri grove)
  day4: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/9ci9apzf_11.IMGP9958.jpeg",  // 11.IMGP9958 (Tuesday - Coromandel view)
  day5: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/x5z22gry_12.Thai%20Massage.jpg", // 12.Thai Massage (Wednesday)
  day6: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/6v77rc8c_17.%20Sun%20through%20the%20clouds.jpg", // 17.Sun through the clouds
  day7: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/mvi9j8qm_IMGP8492.jpeg", // IMGP8492 (farewell)

  // ---------- ACCOMMODATION ----------
  stayHero: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/yhu8eqoe_16.%20flax%20Mill%20Bay%20accommodation.jpg", // 16.Flax Mill Bay accommodation
  staySmall: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/4pelyus2_15.Flaxmill-Bay-Beach-011-1-1024x683%202.jpg", // 15.Flaxmill Bay Beach 011

  // ---------- TEAM ----------
  verna: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/zykwkgac_18%20Verna.jpg",   // 18.Verna
  deirdre: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/cbey3967_19.%20Deirdre%20IMGP9818.jpg", // 19.Deirdre IMGP9818

  // ---------- DATES / CALENDAR ----------
  calendarBg: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/mcnajgjs_IMGP8484.jpeg", // IMGP8484

  // ---------- TESTIMONIALS ----------
  testimonialBg: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/os549rlk_IMGP8897.jpeg", // IMGP8897

  // ---------- FAQ thumbnails ----------
  faq1: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/asmv0j1d_Coromandel%20Aroha-%20Nui%20Logo.png", // Spiritual tradition — Coromandel Aroha-Nui logo (small)
  faq2: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/4yxtro2d_IMGP5479.jpg", // Prior experience — IMGP5479
  faq3: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/10c6zyh5_IMGP9798.jpeg", // Facilitators — IMGP9798 (Deirdre)
  faq4: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/dxjtegyb_IMGP4001.jpg", // Solo travellers — IMGP4001
  faq5: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/vha42wkt_5%2CIMGP5475-2.jpg", // What should I bring — IMGP5475 (workshop session)
  faq6: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/h6509feo_IMGP2333.jpeg", // Rest & solitude — IMGP2333 (forest path)
  faq7: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/79uuaitx_IMGP9964.jpeg", // Get in touch — IMGP9964 (Hahei swim)
  faq8: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/m9itc1zo_IMGP1861.jpeg", // How do I get there — IMGP1861 (Hahei beach)

  // ---------- FOOTER ----------
  footerStretch: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/1rr48bp7_2.Aerial-004-19-1024x683.jpg", // 2.Aerial-004 (aerial of Flaxmill Bay)

  // ---------- LOGO ----------
  // Coromandel Aroha-Nui logo — transparent background, used in nav + footer + About
  logo: "https://customer-assets.emergentagent.com/job_retreat-getaway/artifacts/asmv0j1d_Coromandel%20Aroha-%20Nui%20Logo.png",
};

export const NAV_LINKS = [
  { id: "welcome", label: "Welcome" },
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "retreats", label: "Retreats" },
  { id: "itinerary", label: "Itinerary" },
  { id: "stay", label: "Stay" },
  { id: "team", label: "Team" },
  { id: "explore", label: "Explore" },
  { id: "dates", label: "Dates" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
];

export const TAGLINE = "Love Yourself. Love Your Life. Love Your Spirit.";

// ---------- EXPERIENCE — 6 gold-framed hearts ----------
export const EXPERIENCE_CARDS = [
  {
    img: "exp1",
    heading: "Spiritual Awakening",
    sub: "Workshops & Practice",
    text: "Four expert-led workshops on becoming spiritually awake and aware, practising your innate spiritual gifts. Designed as open-forum discussions and hands-on exercises. You'll learn and grow at your own pace. Non-dogmatic, welcoming to all backgrounds.",
  },
  {
    img: "exp2",
    heading: "Nature & Adventure",
    sub: "Explore & Discover",
    text: "Step outside and enjoy walking, swimming, and exploring the natural beauty and beaches of the Coromandel.",
  },
  {
    img: "exp3",
    heading: "Connection",
    sub: "Community & Belonging",
    text: "These retreats bring light-hearted, like-minded people together to share ideas and conversation. Groups are intentionally kept small — just 12 people. Real connection happens over shared meals, sharing circles, and having fun.",
  },
  {
    img: "exp4",
    heading: "Relaxing Day",
    sub: "Restore & Replenish",
    text: "Pamper yourself with a traditional Thai massage and a soak in the Lost Springs Mineral pools.",
  },
  {
    img: "exp5",
    heading: "Freedom to Be You",
    sub: "Your Pace · Your Way",
    text: "This is your holiday. You have complete freedom to come and go as you wish — participate or not, solitude or community. It is entirely your choice.",
  },
  {
    img: "exp6",
    heading: "Delicious Food",
    sub: "Wholesome & Nourishing",
    text: "18 catered meals. Breakfast with your house-mates, shared lunches and dinners lovingly prepared by Deirdre — an excellent cook.",
  },
];

// ---------- WORKSHOP BOXES (clickable, route to article docs) ----------
// docHref will be replaced with real PDF/article URLs once uploaded.
export const WORKSHOP_BOXES = [
  {
    id: "spiritual-awakening",
    title: "Spiritual Awakening",
    bg: "#d9c08a",        // soft honey gold
    text: "#5b223f",
    docHref: "#workshop-1",
  },
  {
    id: "energy-healing",
    title: "Energy Healing & Expansion",
    bg: "#d9c08a",        // soft honey gold
    text: "#5b223f",
    docHref: "#workshop-2",
  },
  {
    id: "awakening-consciousness",
    title: "Awakening to Consciousness",
    bg: "#d9c08a",        // soft honey gold
    text: "#5b223f",
    docHref: "#workshop-3",
  },
  {
    id: "opening-heart",
    title: "Opening the Heart",
    bg: "#d9c08a",        // soft honey gold
    text: "#5b223f",
    docHref: "#workshop-4",
  },
];

export const EBOOK_URL = "https://vernacarrspiritualhealing.com/wp-content/uploads/2023/11/Wisdom-for-changing-consciousness-2023.pdf";
export const COROMIND_URL = "https://coromind.nz/the-power-of-conscious-energy-healing/";
export const VERNA_SITE = "vernacarrspiritualhealing.com";
